import object from '@mailobj-browser/front/js/utils/object.js'

export const block = 'ea_chat'

export const elements = object(null, {
  call: `${block}__call`,
  chat: `${block}__chat`,
  control: `${block}__meet_control`,
  control_new_window: `${block}__meet_control_new_window`,
  join: `${block}__join`,
  meet: `${block}__meet`,
  meet_camera: `${block}__meet_camera`,
  meet_connect: `${block}__meet_connect`,
  meet_controls: `${block}__meet_controls`,
  meet_device_microphone_visualizer: `${block}__meet_device_microphone_visualizer`,
  meet_device_speaker: `${block}__meet_device_speakers`,
  meet_device_speaker_start: `${block}__meet_device_speaker_start`,
  meet_device_speaker_stop: `${block}__meet_device_speaker_stop`,
  meet_device_camera: `${block}__meet_device_camera`,
  meet_gallery: `${block}__meet_gallery`,
  meet_gallery_cameras: `${block}__meet_gallery_cameras`,
  meet_sharing: `${block}__meet_sharing`,
  meet_sharing_display_participants: `${block}__meet_sharing_display_participants`,
  meet_organizer_enabled: `${block}__meet_organizer_enabled`,
  messages: `${block}__messages`,
  messages_in: `${block}__messages_in`,
  message_meeting: `${block}__message_meeting`,
  rte_input: `${block}__rte_input`,
  rte_submit: `${block}__rte_submit`,
  scroll_to_bottom_button: `${block}__scroll_to_bottom_button`,
  thread: `${block}__thread`,
  thread_details: `${block}__thread_details`,
  thread_top: `${block}__thread_top`,
  camera_participant_name: `${block}__camera_participant_name`,
})

export const modifiers = object(null, {
  meet_controls: object(null, {
    visible: `${elements.meet_controls}-visible`,
  }),
  meet_connect: object(null, {
    ready: `${elements.meet_controls}-ready`,
  }),
  meet_device_microphone_visualizer: object(null, {
    enabled: `${elements.meet_device_microphone_visualizer}-enabled`
  }),
  meet_device_speaker: object(null, {
    playing: `${elements.meet_device_speaker}-playing`
  }),
  meet_device_camera: object(null, {
    playing: `${elements.meet_device_camera}-playing`
  }),
  meet_sharing: object(null, {
    running: `${elements.meet_sharing}-running`
  }),
  participant: object(null, {
    hidden: `${elements.meet_camera}-hidden`,
    myself: `${elements.meet_camera}-myself`,
    isOrganizer: `${elements.meet_camera}-is_organizer`,
    notConnected: `${elements.meet_camera}-not_connected`,
    portrait: `${elements.meet_camera}-portrait`,
    landscape: `${elements.meet_camera}-landscape`
  }),
  participant_name: object(null, {
    talking: `${elements.camera_participant_name}-talking`
  })
})
